{
  "resourceGroupsAdmin": {
    "title": "Grupy zasobów",
    "resourceTypes": "Typy zasobów",
    "groups": "Grupy",
    "addGroup": "Dodaj grupę",
    "cancel": "Anuluj",
    "disabledTooltip": "Grupy są wyłączone w zakładce Pola dla typu {{name}}. Kliknij, aby je włączyć.",
    "disabledReadOnlyTooltip": "Grupy są wyłączone w zakładce Pola dla typu {{name}}. Poproś administratora o ich włączenie dla aktywnego typu zasobu.",
    "disabledDescription": "Grupy są wyłączone w zakładce Pola dla typu {{name}}. Włącz pole Grupy, aby zarządzać grupami tego typu zasobu.",
    "enableGroups": "Włącz grupy",
    "enableTitle": "Włączyć grupy dla typu {{name}}?",
    "enableDescription": "Pole Grupy zostanie włączone w zakładce Pola w globalnych ustawieniach typu {{name}}. Istniejące grupy zostaną zachowane; pozostałe pola i ustawienia poszczególnych przestrzeni roboczych nie zostaną zmienione.",
    "enabling": "Włączanie…",
    "enableFailed": "Nie udało się włączyć grup. Spróbuj ponownie.",
    "description": "Edytuj nazwy i kolory, usuwaj grupy lub przeciągaj wiersze, aby zmienić ich kolejność.",
    "archivedDescription": "Przeglądaj zarchiwizowane grupy tego typu zasobu. Przywróć grupę, aby ponownie była dostępna.",
    "restore": "Przywróć grupę",
    "restoreTitle": "Przywrócić grupę „{{name}}”?",
    "restoreDescription": "Grupa znów będzie aktywna dla swojego typu zasobu. Jej nazwa, kolor i istniejące przypisania zasobów zostaną zachowane.",
    "restoreLabel": "Przywróć {{name}}",
    "emptyArchivedGroups": "Brak zarchiwizowanych grup",
    "emptyArchivedGroupsDescription": "Ten typ zasobu nie ma zarchiwizowanych grup.",
    "colour": "Kolor",
    "nameLabel": "Nazwa grupy {{name}}",
    "colourLabel": "Kolor grupy {{name}}",
    "saved": "Zaktualizowano grupy",
    "saveFailed": "Nie udało się zapisać zmian. Spróbuj ponownie.",
    "nameRequired": "Podaj nazwę grupy.",
    "entityName": "grupa",
    "emptyGroups": "Brak grup",
    "emptyGroupsDescription": "Ten typ zasobu nie ma aktywnych grup.",
    "emptyTypes": "Brak typów zasobów",
    "emptyTypesDescription": "Utwórz typ zasobu, aby zarządzać jego grupami.",
    "loadFailed": "Nie udało się wczytać grup.",
    "typesFailed": "Nie udało się wczytać typów zasobów."
  },
  "core_fields": {
    "first_name": "Imię",
    "last_name": "Nazwisko",
    "nick_name": "Pseudonim",
    "full_name": "Imię i nazwisko",
    "role": "Rola",
    "import_id": "ID importu",
    "contact_type": "Typ kontaktu",
    "resource_type_id": "Typ zasobu",
    "represented_by_id": "Reprezentowany przez",
    "profile_picture": "Zdjęcie profilowe",
    "rates": "Stawki",
    "tags": "Tagi",
    "groups": "Grupy",
    "locations": "Lokalizacje",
    "emails": "Adresy e‑mail",
    "websites": "Strony internetowe",
    "phone_numbers": "Numery telefonów",
    "socials": "Social media",
    "pronouns": "Zaimki",
    "code": "Kod",
    "icon": "Ikona",
    "title": "Tytuł",
    "production_type_id": "Typ produkcji",
    "production_template_id": "Szablon produkcji",
    "production_date": "Data produkcji",
    "shotflow_instance": "Instancja Shotflow",
    "status_id": "Status",
    "description": "Opis",
    "color": "Kolor",
    "timezone": "Strefa czasowa",
    "events": "Harmonogram",
    "production_locations": "Lokalizacje",
    "budget_amount": "Kwota budżetu",
    "estimated_total": "Szacowany koszt",
    "actual_total": "Rzeczywisty koszt",
    "budget_expenses": "Wydatki budżetowe",
    "budget_expenses.name": "Nazwa",
    "budget_expenses.description": "Opis",
    "budget_expenses.estimate": "Szacunek",
    "budget_expenses.archived": "Zarchiwizowane",
    "budget_expenses.group_id": "Grupa",
    "budget_expenses.slot_category_id": "Kategoria",
    "budget_expenses.expenses": "Koszty",
    "budget_expenses.expenses.booking_id": "Rezerwacja",
    "budget_expenses.expenses.booking.resource_id": "Zasób",
    "budget_expenses.expenses.commit_vendor": "Dostawca",
    "budget_expenses.expenses.commit": "Zadeklarowane",
    "budget_expenses.expenses.created_at": "Data utworzenia",
    "budget_expenses.expenses.updated_at": "Data aktualizacji",
    "budget_expenses.expenses.slot_category_id": "Kategoria",
    "budget_expenses.expenses.receipts": "Paragony",
    "resourcing_at": "Data przydziału zasobów",
    "ready_at": "Data gotowości",
    "completed_at": "Data ukończenia",
    "cancelled_at": "Data anulowania",
    "booking_type_id": "Typ rezerwacji",
    "rate": "Stawka",
    "note": "Notatka",
    "contracts": "Umowy",
    "invoices": "Faktury",
    "submitted_date": "Data złożenia",
    "agreed_date": "Data uzgodnienia",
    "pencilled_at": "Wstępnie zaplanowano",
    "confirmed_at": "Data potwierdzenia",
    "createdAt": "Data utworzenia",
    "updatedAt": "Data aktualizacji",
    "archived": "Zarchiwizowane",
    "user_id": "Właściciel",
    "bookings": "Rezerwacje",
    "public_id": "ID publiczne",
    "status": "Status",
    "public_title": "Publiczny tytuł",
    "public_description": "Publiczny opis",
    "confirmation_text": "Tekst potwierdzenia",
    "enable_notifications": "Włącz powiadomienia",
    "published": "Opublikowane",
    "deadline": "Termin",
    "public": "Publiczny",
    "expanded": "Rozszerzone",
    "public_feedback": "Publiczny feedback",
    "layout": "Układ",
    "enable_voting": "Włącz głosowanie",
    "enable_commenting": "Włącz komentowanie",
    "billing": "Rozliczenia",
    "social": "Social",
    "hard_drive": "Dysk twardy",
    "from_date": "Od daty",
    "to_date": "Do daty",
    "call_time": "Godzina zbiórki",
    "resource_slots": "Sloty zasobów",
    "resource": "Zasób",
    "resource_slot_assignments": "Przydziały slotów zasobów",
    "organisation": "Organizacja",
    "organisation_id": "Organizacja",
    "availability": "Dostępność",
    "all": "Wszystko",
    "published_at": "Data publikacji",
    "callsheet_date": "Data zbiórki"
  },
  "rate_intervals": {
    "DAILY": "Dziennie",
    "HOURLY": "Godzinowo",
    "FIXED": "Stała",
    "ITEM": "Za element"
  },
  "rateInput": {
    "currencyAria": "Waluta",
    "amountAria": "Kwota stawki",
    "intervalAria": "Jednostka rozliczenia",
    "quantityAria": "Ilość",
    "currencyTooltip": "Waluta używana dla tej stawki.",
    "amountTooltip": "Kwota stawki (przed ilością i opłatami).",
    "intervalTooltip": "Sposób rozliczenia stawki, np. godzinowo lub dziennie.",
    "multiplyTooltip": "Stawka jest mnożona przez ilość, aby uzyskać sumę wiersza.",
    "quantityTooltip": "Liczba jednostek, których dotyczy ta stawka."
  },
  "rateEditor": {
    "name": "Nazwa",
    "namePlaceholder": "np. Stawka dzienna",
    "amount": "Kwota",
    "amountPlaceholder": "0,00",
    "currency": "Waluta",
    "billingUnit": "Jednostka rozliczenia",
    "fees": "Opłaty doliczane",
    "feesHint": "% kwoty",
    "note": "Notatka",
    "optional": "opcjonalnie",
    "notePlaceholder": "Warunki, co obejmuje, zastrzeżenia",
    "noAmount": "Brak kwoty",
    "unnamed": "Stawka bez nazwy",
    "fee": {
      "agency": "Agencja",
      "payroll": "Payroll",
      "processing": "Processing"
    },
    "feeFull": {
      "agency": "Opłata agencji",
      "payroll": "Opłata payroll",
      "processing": "Opłata processing"
    },
    "feeSummary": "+{{percent}}% {{fee}}",
    "feeSpoken": "{{percent}}% {{fee}}",
    "plusFees": "plus {{fees}}",
    "unit": {
      "DAILY": "/ dzień",
      "HOURLY": "/ godz.",
      "FIXED": "ryczałt",
      "ITEM": "/ szt."
    },
    "unitSpoken": {
      "DAILY": "za dzień",
      "HOURLY": "za godzinę",
      "FIXED": "ryczałtem",
      "ITEM": "za sztukę"
    },
    "unitOption": {
      "DAILY": "Za dzień",
      "HOURLY": "Za godzinę",
      "FIXED": "Ryczałt",
      "ITEM": "Za sztukę"
    },
    "autoName": {
      "DAILY": "Stawka dzienna",
      "HOURLY": "Stawka godzinowa",
      "FIXED": "Ryczałt",
      "ITEM": "Stawka za sztukę"
    },
    "withFees": "Z opłatami",
    "howCalculated": "Rozbicie",
    "breakdown": {
      "rate": "Stawka",
      "agency": "Agencja {{percent}}% stawki",
      "payroll": "Payroll {{percent}}% z {{base}} (stawka minus agencja)",
      "processing": "Processing {{percent}}% z {{base}} (suma częściowa)",
      "total": "Z opłatami"
    },
    "rateCard": "Karta stawek",
    "rateCardHint": "Zarządzana w Ustawienia › Karty stawek. Zmiany karty obowiązują także tutaj.",
    "detachAndEdit": "Odłącz i edytuj",
    "manageRateCards": "Zarządzaj kartami stawek",
    "rateCardUnavailable": "Niedostępna",
    "rateCardUnavailableHint": "Ta karta stawek została zarchiwizowana albo nie masz do niej dostępu. Usuń ją lub zastąp aktualną kartą.",
    "rateCardFallbackName": "Karta stawek #{{id}}",
    "errors": {
      "nameRequired": "Podaj nazwę, np. Stawka dzienna.",
      "amountRequired": "Podaj kwotę.",
      "currencyRequired": "Wybierz walutę.",
      "amountInvalid": "Wpisz liczbę, np. 850 albo 850,50.",
      "amountNegative": "Kwota nie może być ujemna.",
      "amountDecimals": "Użyj najwyżej {{digits}} miejsc po przecinku.",
      "amountNoDecimals": "Kwoty w {{currency}} nie mają części ułamkowej.",
      "feeRange": "{{fee}}: wpisz liczbę całkowitą od 0 do 100.",
      "unitUnsupported": "Wybierz: za dzień, za godzinę albo ryczałt.",
      "amountTooLarge": "Podaj kwotę nie większą niż {{max}}."
    }
  },
  "validation": {
    "required": "To pole jest wymagane",
    "url": "To nie jest poprawny link",
    "email": "To nie jest poprawny adres e-mail",
    "phone_number": "To nie jest poprawny numer telefonu"
  },
  "standard-date-filter": {
    "timestamp": {
      "last7Days": "Ostatnie 7 dni",
      "last30Days": "Ostatnie 30 dni",
      "last90Days": "Ostatnie 90 dni"
    },
    "scheduled": {
      "today": "Dzisiaj",
      "tomorrow": "Jutro",
      "nextWeek": "Następny tydzień",
      "nextMonth": "Następny miesiąc"
    },
    "custom": {
      "last7Days": "Ostatnie 7 dni",
      "last30Days": "Ostatnie 30 dni",
      "last90Days": "Ostatnie 90 dni",
      "today": "Dzisiaj",
      "tomorrow": "Jutro",
      "nextWeek": "Następny tydzień",
      "nextMonth": "Następny miesiąc"
    }
  },
  "AccountSettingsPronouns": {
    "sectionLabel": "Zasoby",
    "title": "Opcje zaimków",
    "description": "Określ, jakie etykiety zaimków są dostępne przy edycji osób (Individual, Talent, Agent).",
    "listTitle": "Dozwolone zaimki",
    "help": "Te wartości są sprawdzane przy zapisie zasobu. Przeciągnij uchwyt, aby zmienić kolejność; duplikaty są usuwane przy zapisie.",
    "dragHandleLabel": "Przeciągnij, aby zmienić kolejność",
    "optionPlaceholder": "np. Oni/Ich",
    "addOption": "Dodaj opcję",
    "remove": "Usuń",
    "save": "Zapisz",
    "saved": "Zapisano opcje zaimków",
    "saveFailed": "Nie udało się zapisać opcji zaimków"
  },
  "online_status": {
    "online": "Jesteś online",
    "offline": "Jesteś offline",
    "toast_offline": "Jesteś offline",
    "toast_online": "Połączenie przywrócone"
  },
  "enterprise": {
    "globalScopeLabel": "Globalne",
    "tags": "Tagi",
    "rateCards": "Karty stawek",
    "expenseTypes": "Typy wydatków",
    "slotCategories": "Kategorie slotów",
    "loadingWorkspaces": "Ładowanie przestrzeni roboczych…",
    "workspacesUnavailable": "Przestrzenie robocze niedostępne",
    "emptyWorkspaces": "Brak dostępnych przestrzeni roboczych",
    "emptyWorkspacesHint": "To nie powinno się zdarzyć. Skontaktuj się z pomocą techniczną.",
    "teamsSectionLabel": "Zespoły",
    "loadingTeams": "Ładowanie zespołów…",
    "teamsUnavailable": "Zespoły niedostępne",
    "emptyTeams": "Brak zespołów w tej przestrzeni roboczej",
    "emptyTeamsHint": "To nie powinno się zdarzyć. Skontaktuj się z pomocą techniczną.",
    "teamsSettingsLabel": "Ustawienia zespołu",
    "newTeam": "Nowy zespół",
    "newWorkspace": "Nowa przestrzeń robocza",
    "switchWorkspace": "Przełącz przestrzeń roboczą",
    "createWorkspace": "Utwórz przestrzeń roboczą",
    "createWorkspaceDescription": "Dodaj nową przestrzeń roboczą enterprise do organizacji.",
    "editWorkspace": "Edytuj przestrzeń roboczą",
    "editWorkspaceDescription": "Zaktualizuj nazwę i ikonę przestrzeni roboczej.",
    "createTeam": "Utwórz zespół",
    "createTeamDescription": "Dodaj nowy zespół w tej przestrzeni roboczej.",
    "editTeam": "Edytuj zespół",
    "editTeamDescription": "Zaktualizuj nazwę, ikonę i kolor zespołu.",
    "archive": "Archiwizuj",
    "unarchive": "Przywróć",
    "activeTab": "Aktywne",
    "archivedTab": "Zarchiwizowane",
    "emptyArchivedWorkspaces": "Brak zarchiwizowanych przestrzeni roboczych",
    "emptyArchivedTeams": "Brak zarchiwizowanych zespołów w tej przestrzeni",
    "edit": "Edytuj",
    "create": "Utwórz",
    "save": "Zapisz",
    "fieldName": "Nazwa",
    "fieldIcon": "Ikona",
    "fieldIconColor": "Kolor ikony",
    "pickIconColor": "Wybierz kolor",
    "manageEntity": "Zarządzaj",
    "manageEnterprise": "Zarządzaj enterprise",
    "visitorManagement": "Zarządzanie gośćmi",
    "organizationTalents": "Talenty organizacji",
    "manageEnterpriseDescription": "Twórz, edytuj i archiwizuj przestrzenie robocze oraz zespoły w organizacji.",
    "workspacesTitle": "Przestrzenie robocze",
    "teamsTitle": "Zespoły",
    "teamsForWorkspace": "Zespoły w {{workspace}}",
    "selectWorkspaceHint": "Wybierz przestrzeń roboczą, aby zarządzać jej zespołami",
    "teamDashboard": "Pulpit"
  },
  "bookingConfirmationSettings": {
    "title": "Szablon potwierdzenia rezerwacji",
    "description": "Skonfiguruj szablon e-maila potwierdzającego rezerwację dla tej przestrzeni roboczej.",
    "templatePlaceholder": "Napisz treść e-maila potwierdzającego…",
    "insertPlaceholder": "Wstaw blok",
    "insertPlaceholderMenuLabel": "Pola",
    "insertPlaceholderSectionsLabel": "Bloki",
    "hints": {
      "first_name": "Imię zasobu",
      "full_name": "Pełne imię i nazwisko zasobu",
      "booking_status": "Aktualny status rezerwacji",
      "booking_role": "Rola w tej rezerwacji",
      "production_title": "Tytuł produkcji",
      "booking_estimated_total": "Szacowany koszt rezerwacji",
      "booking_note": "Notatka do rezerwacji",
      "section": {
        "booking_events": "Powtarza się dla każdej daty lub godziny rezerwacji",
        "booking_estimated_total": "Tylko gdy ustawiono koszt",
        "booking_note": "Tylko gdy ustawiono notatkę"
      }
    },
    "frameTitle": "Edytor szablonu",
    "previewLabel": "Podgląd",
    "viewModeEditor": "Kod",
    "viewModePreview": "Podgląd",
    "viewModeSplit": "Podzielony",
    "emptyTip": "Wysłanie potwierdzenia rezerwacji wymaga niepustego szablonu.",
    "save": "Zapisz",
    "cancel": "Anuluj",
    "saveSuccess": "Zaktualizowano szablon potwierdzenia rezerwacji",
    "saveFailed": "Nie udało się zaktualizować szablonu potwierdzenia rezerwacji",
    "loadFailed": "Nie udało się wczytać szablonu potwierdzenia rezerwacji",
    "missingWorkspace": "Otwórz tę stronę w przestrzeni roboczej, aby edytować jej szablon potwierdzenia."
  },
  "workspaceGeneralSettings": {
    "title": "Ogólne",
    "description": "Zarządzaj ogólnymi ustawieniami tej przestrzeni roboczej",
    "missingWorkspace": "Otwórz tę stronę w przestrzeni roboczej, aby edytować jej ustawienia ogólne.",
    "brandImage": {
      "title": "Logo marki",
      "description": "Jeszcze nie jest używane w aplikacji.",
      "fieldLabel": "Logo marki"
    },
    "defaultCurrency": {
      "title": "Domyślna waluta",
      "description": "Używana, gdy nowa produkcja, stawka lub wydatek nie określa waluty.",
      "fieldLabel": "Waluta"
    },
    "defaultLocale": {
      "title": "Język",
      "description": "Język stron publicznych i e-maili wysyłanych z tego workspace'u.",
      "fieldLabel": "Język"
    },
    "defaultCountryCode": {
      "title": "Lokalizacja",
      "description": "Domyślny kraj przy wpisywaniu krajowych numerów telefonu.",
      "fieldLabel": "Kraj"
    },
    "saveSuccess": "Zaktualizowano ustawienia",
    "saveFailed": "Nie udało się zaktualizować ustawień",
    "loadFailed": "Nie udało się wczytać ustawień",
    "defaultTimezone": {
      "title": "Strefa czasowa",
      "description": "Domyślna strefa czasowa harmonogramów, wydarzeń i callsheetów w tym workspace.",
      "fieldLabel": "Strefa czasowa"
    },
    "roleMissingDays": {
      "title": "Alerty produkcji",
      "description": "Otwarte lub obsadzane produkcje, które zaczynają się w ciągu tylu dni, są oznaczane jako zagrożone.",
      "fieldLabel": "Alert przed zdjęciami",
      "unit": "dni"
    },
    "tagsFixed": {
      "title": "Tagi",
      "description": "Tagi są wspólne dla wszystkich przestrzeni roboczych. Gdy stałe tagi są włączone, osoby w tej przestrzeni wybierają tylko istniejące tagi i nie mogą tworzyć nowych podczas edycji zasobu. Nowe tagi dodaje się w globalnych ustawieniach tagów.",
      "fieldLabel": "Stałe tagi"
    }
  },
  "publicProfileSettings": {
    "title": "Profil publiczny",
    "description": "Ustaw wygląd opublikowanych stron zgodnie z marką.",
    "sections": {
      "brandImage": "Obraz marki",
      "names": "Nazwy",
      "brandColors": "Kolory marki"
    },
    "fields": {
      "organizationName": "Nazwa organizacji",
      "organizationNamePlaceholder": "Firma",
      "teamName": "Nazwa zespołu",
      "teamNamePlaceholder": "Zespół",
      "backgroundColour": "Kolor tła",
      "primaryColour": "Kolor główny",
      "secondaryColour": "Kolor dodatkowy",
      "pickColour": "Wybierz kolor"
    },
    "frameTitle": "Branding",
    "viewModeEditor": "Ustawienia",
    "viewModePreview": "Podgląd",
    "viewModeSplit": "Podzielony",
    "previewLabel": "Podgląd brandingu udostępnianych stron",
    "previewHint": "Przybliżony wygląd na publicznych calloutach, e-mailach i shortlistach. Nie jest pikselowo dokładny.",
    "previewCalloutTitle": "Publiczny callout",
    "previewEmailTitle": "Nagłówek e-maila",
    "previewShortlistTitle": "Publiczna shortlista",
    "previewSampleCompany": "Twoja organizacja",
    "previewSampleTeam": "Twój zespół",
    "previewSampleCalloutTitle": "Otwarty callout",
    "previewSampleCalloutDescription": "Kandydaci widzą tu Twoje logo i kolory.",
    "previewSampleCta": "Aplikuj",
    "previewSampleEmailSubject": "Aktualizacja rezerwacji",
    "previewSampleEmailBody": "Cześć Alex, masz aktualizację od {{team}}.",
    "previewSampleShortlistTitle": "Shortlista kampanii wiosennej",
    "previewSampleShortlistBadge": "Udostępnione klientowi",
    "save": "Zapisz",
    "cancel": "Anuluj",
    "saveSuccess": "Zaktualizowano profil publiczny",
    "saveFailed": "Nie udało się zaktualizować profilu publicznego",
    "loadFailed": "Nie udało się wczytać ustawień profilu publicznego",
    "missingTeam": "Otwórz tę stronę w zespole, aby edytować jego profil publiczny."
  },
  "resourceTypesAdmin": {
    "globalTitle": "Typy zasobów",
    "globalDescription": "Zarządzaj ogólnosystemowymi typami zasobów synchronizowanymi między przestrzeniami roboczymi.",
    "workspaceTitle": "Typy zasobów",
    "workspaceDescription": "Zarządzaj typami zasobów widocznymi w tej przestrzeni roboczej oraz jej polami.",
    "name": "Nazwa",
    "type": "Typ",
    "workspaces": "Przestrzenie robocze",
    "assignWorkspaces": "Zarządzaj przestrzeniami roboczymi",
    "searchWorkspaces": "Szukaj przestrzeni roboczych…",
    "openInWorkspace": "Otwórz ustawienia {{workspace}}",
    "workspacesTabHint": "Typy zasobów nie są domyślnie przypisane do przestrzeni roboczych. Włącz je tam, gdzie powinny być widoczne.",
    "workspacesSearchNoResults": "Nie znaleziono przestrzeni roboczych",
    "workspacesTabEmpty": "Brak przestrzeni roboczych w tej organizacji",
    "workspacesLoadError": "Nie udało się wczytać przestrzeni roboczych",
    "newResourceType": "Nowy typ zasobu",
    "createTitle": "Utwórz typ zasobu",
    "createDescription": "Utwórz typ zasobu dostępny w całej organizacji.",
    "fieldName": "Nazwa",
    "fieldIcon": "Ikona",
    "fieldMechanism": "Typ",
    "mechanismLockedHint": "Nie można edytować po utworzeniu.",
    "chooseIcon": "Wybierz ikonę",
    "active": "Aktywne",
    "inactive": "Nieaktywne",
    "activate": "Aktywuj",
    "deactivate": "Dezaktywuj",
    "activateFieldTitle": "Aktywować pole?",
    "activateFieldDescription": "Czy na pewno chcesz aktywować to pole?",
    "deactivateFieldTitle": "Dezaktywować pole?",
    "deactivateFieldDescription": "Czy na pewno chcesz dezaktywować to pole? Nie utracisz żadnych danych.",
    "edit": "Edytuj",
    "archive": "Archiwizuj",
    "unarchive": "Przywróć",
    "archiveSuccess": "Typ zasobu został zarchiwizowany",
    "unarchiveSuccess": "Typ zasobu został przywrócony",
    "enable": "Włącz w przestrzeni roboczej",
    "disable": "Wyłącz w przestrzeni roboczej",
    "enableSuccess": "Typ zasobu został włączony w przestrzeni roboczej",
    "disableSuccess": "Typ zasobu został wyłączony w przestrzeni roboczej",
    "disabledInWorkspaceTitle": "Ten typ zasobu jest wyłączony w {{workspace}}",
    "disabledInWorkspaceDescription": "Członkowie tej przestrzeni roboczej nie zobaczą zasobów tego typu, dopóki nie zostanie włączony.",
    "disableConfirmTitle": "Wyłączyć typy zasobów?",
    "disableConfirmDescription": "Wybrane typy zasobów nie będą już widoczne w tej przestrzeni roboczej. Nie utracisz żadnych danych.",
    "detailsTab": "Szczegóły",
    "detailsSaveSuccess": "Typ zasobu zapisany",
    "detailsSaveFailed": "Nie udało się zapisać typu zasobu",
    "fieldsTab": "Pola",
    "globalDetailSubtitle": "Edytuj ten typ zasobu dla wszystkich przestrzeni roboczych.",
    "workspaceDetailSubtitle": "Edytuj opcje tego typu zasobu specyficzne dla przestrzeni roboczej. Aby edytować pozostałe ustawienia, przejdź do strony globalnych typów zasobów.",
    "viewGlobalSettings": "Zobacz ustawienia globalne",
    "viewGlobalResourceTypes": "Zobacz globalne typy zasobów",
    "globalFieldsTitle": "Pola globalne",
    "globalFieldsHint": "Pola edytowane i dodawane tutaj zostaną zastosowane we wszystkich przestrzeniach roboczych. Aby edytować pola specyficzne dla przestrzeni roboczej, przejdź do jej ustawień.",
    "workspaceGlobalFieldsHint": "Pola globalne można edytować wyłącznie poza przestrzenią roboczą, w konfiguracji globalnej.",
    "configureGlobalFields": "Konfiguruj pola globalne",
    "workspaceFieldsTitle": "Pola: {{workspace}}",
    "workspaceFallbackName": "Przestrzeń robocza",
    "required": "Wymagane",
    "locked": "Zablokowane",
    "filterable": "Filtrowalne",
    "requiredEnabledToast": "Pole oznaczone jako wymagane",
    "requiredDisabledToast": "Pole nie jest już wymagane",
    "filterableEnabledToast": "Pole jest teraz filtrowalne",
    "filterableDisabledToast": "Pole nie jest już filtrowalne",
    "fieldPropertyUpdateError": "Nie udało się zaktualizować pola",
    "fieldType": "Typ",
    "addField": "Dodaj pole",
    "addFieldAssignPrompt": "Zostanie dodane do",
    "searchFields": "Szukaj pól…",
    "fieldsSearchNoResults": "Nie znaleziono pól",
    "dangerousActions": "Niebezpieczne akcje",
    "archiveSectionTitle": "Archiwizuj typ zasobu",
    "archiveSectionDescription": "Dane zostaną zachowane, ale użytkownicy we wszystkich przestrzeniach roboczych nie będą już widzieć tego typu zasobu",
    "unarchiveSectionTitle": "Przywróć typ zasobu",
    "unarchiveSectionDescription": "Przywróć ten typ zasobu, aby można go było ponownie włączać w przestrzeniach roboczych.",
    "entityNameSingular": "typ zasobu",
    "entityNamePlural": "typy zasobów",
    "fieldEntityNameSingular": "pole",
    "fieldEntityNamePlural": "pola",
    "batchArchiveSelected": "Archiwizuj wybrane",
    "batchUnarchiveSelected": "Przywróć wybrane",
    "batchActivateSelected": "Aktywuj wybrane",
    "batchDeactivateSelected": "Dezaktywuj wybrane",
    "batchActivateFieldsNone": "Brak pól do aktywowania",
    "batchDeactivateFieldsNone": "Zablokowane pola systemowe nie mogą zostać dezaktywowane",
    "batchEnableSelected": "Włącz wybrane",
    "batchDisableSelected": "Wyłącz wybrane",
    "reorderFields": "Zmień kolejność pola",
    "emptyActive": "Brak aktywnych typów zasobów",
    "emptyInactive": "Brak nieaktywnych typów zasobów",
    "emptyArchived": "Brak zarchiwizowanych typów zasobów",
    "emptyFields": "Brak pól",
    "emptyInactiveFields": "Brak nieaktywnych pól",
    "loadError": "Nie udało się wczytać tego typu zasobu",
    "localPreviewNote": "Włączanie w przestrzeniach roboczych i pola są zapisywane lokalnie w tej przeglądarce, dopóki backend ich nie obsłuży.",
    "assignResourceTypesAction": "Włącz typy zasobów",
    "assignResourceTypesTitle": "Włącz typy zasobów",
    "assignResourceTypesSearchPlaceholder": "Szukaj typów zasobów…",
    "assignResourceTypesSelectedCount": "Wybrano: {{count}}",
    "assignResourceTypesSelectPrompt": "Wybierz typy zasobów do włączenia w tej przestrzeni roboczej",
    "assignResourceTypesUnselectAll": "Odznacz wszystkie",
    "assignResourceTypesEmpty": "Wszystkie typy zasobów są już włączone w tej przestrzeni roboczej",
    "assignResourceTypesNoResults": "Nie znaleziono typów zasobów",
    "assignResourceTypesConfirm": "Włącz ({{count}})",
    "assignResourceTypesLoadError": "Nie udało się wczytać typów zasobów",
    "create": "Utwórz",
    "createFailed": "Nie udało się utworzyć typu zasobu",
    "unsavedChangesBeforeUnload": "Masz niezapisane zmiany!",
    "cancel": "Anuluj",
    "mechanisms": {
      "INDIVIDUAL": "Osoba",
      "ORGANIZATION": "Organizacja",
      "LOCATION": "Lokalizacja",
      "ITEM": "Przedmiot",
      "TALENT": "Talent",
      "AGENT": "Agent"
    }
  },
  "app_update": {
    "message": "Dostępna jest nowa wersja aplikacji.",
    "refresh": "Odśwież"
  },
  "app_crash": {
    "title": "Coś poszło nie tak",
    "description": "Aplikacja uległa awarii. Odśwież stronę i spróbuj ponownie lub skontaktuj się z nami po pomoc",
    "refresh": "Odśwież",
    "goToDashboard": "Przejdź do pulpitu",
    "errorLogLabel": "Szczegóły błędu"
  },
  "server_unreachable": {
    "bootstrap": {
      "title": "Nie udało się załadować aplikacji",
      "description_connection": "Nie udało się połączyć z serwerem. Sprawdź połączenie i odśwież stronę.",
      "description_server": "Serwer zwrócił błąd podczas ładowania wymaganych danych. Spróbuj ponownie za chwilę."
    },
    "session": {
      "title": "Nie udało się załadować sesji",
      "description_connection": "Nie udało się połączyć z serwerem, aby wczytać ustawienia konta. Sprawdź połączenie i odśwież stronę.",
      "description_server": "Nie udało się wczytać ustawień konta z powodu błędu serwera. Spróbuj ponownie za chwilę."
    },
    "sign_in": {
      "title": "Logowanie niedostępne",
      "description_connection": "Nie udało się połączyć w celu weryfikacji opcji logowania. Sprawdź połączenie i odśwież stronę.",
      "description_server": "Logowanie jest tymczasowo niedostępne z powodu błędu serwera. Spróbuj ponownie za chwilę."
    },
    "refresh": "Odśwież",
    "goToDashboard": "Przejdź do pulpitu",
    "errorLogLabel": "Szczegóły błędu"
  },
  "not_found": {
    "title": "Nie możemy znaleźć tego, czego szukasz",
    "description": "Sprawdź, czy link jest poprawny i czy jesteś zalogowany. Jeśli problem nadal występuje, jesteśmy do dyspozycji!",
    "contactSupport": "Skontaktuj się z pomocą",
    "goToDashboard": "Przejdź do pulpitu",
    "workspace": {
      "title": "Nie znaleziono workspace",
      "description": "Ten workspace mógł zostać usunięty albo link jest nieprawidłowy"
    },
    "team": {
      "title": "Nie znaleziono zespołu",
      "description": "Ten zespół mógł zostać usunięty albo link jest nieprawidłowy"
    },
    "contact": {
      "title": "Nie znaleziono kontaktu",
      "description": "Ten kontakt mógł zostać zarchiwizowany albo link jest nieprawidłowy"
    },
    "production": {
      "title": "Nie znaleziono produkcji",
      "description": "Ta produkcja mogła zostać zarchiwizowana albo link jest nieprawidłowy"
    },
    "callout": {
      "title": "Nie znaleziono ogłoszenia",
      "description": "To ogłoszenie mogło zostać zarchiwizowane albo link jest nieprawidłowy"
    },
    "callsheet": {
      "title": "Nie znaleziono callsheetu",
      "description": "Ten callsheet mógł zostać zarchiwizowany albo link jest nieprawidłowy"
    },
    "shortlist": {
      "title": "Nie znaleziono shortlisty",
      "description": "Ta shortlista mogła zostać zarchiwizowana albo link jest nieprawidłowy"
    }
  },
  "sandbox": {
    "badge": "Sandbox",
    "title": "Jesteś w środowisku sandbox",
    "subtitle": "Bezpieczne miejsce, by wypróbować nadchodzące zmiany.",
    "isolated": {
      "title": "Pełna izolacja",
      "description": "Nic, co tu zrobisz, nie wpłynie na Twoje konto produkcyjne ani jego dane."
    },
    "early_access": {
      "title": "Wczesny dostęp",
      "description": "Nowe funkcje trafiają tutaj 1–2 tygodnie przed udostępnieniem ich wszystkim użytkownikom."
    },
    "feedback": {
      "title": "Współtwórz nowe funkcje",
      "description": "Zauważyłeś problem lub masz pomysł? Chętnie o tym usłyszymy."
    },
    "send_feedback": "Wyślij opinię",
    "dismiss": "Rozumiem"
  },
  "commandBar": {
    "label": "Szukaj lub utwórz",
    "onThisPage": "Na tej stronie"
  }
}
